"use client";

import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const FINAL_CTA_IMAGE_URL = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/08/teelistclub-final-cta-coastal-golf.png";
export default function FinalDiscoveryCTA() {
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4535" id="finaldiscoverycta" aria-labelledby="finaldiscoverycta-title" className="relative w-full overflow-hidden bg-[#F7F3E9] text-[#073F31]">
      <div className="grid w-full grid-cols-1 lg:min-h-[620px] lg:grid-cols-[46%_54%]">
        {/* Left editorial CTA */}
        <div className="relative z-20 flex min-h-[500px] items-center px-5 py-16 sm:px-8 md:px-12 lg:min-h-[620px] lg:px-16 lg:py-20 xl:px-20 2xl:px-24">
          {/* Subtle paper texture */}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.2]" style={{
          backgroundImage: "radial-gradient(circle at 22% 28%, rgba(184,143,70,0.055) 0, rgba(184,143,70,0.055) 1px, transparent 1px), radial-gradient(circle at 74% 68%, rgba(7,63,49,0.025) 0, rgba(7,63,49,0.025) 1px, transparent 1px)",
          backgroundSize: "28px 28px, 34px 34px"
        }} />

          <div ref={copyRef} className={`relative w-full max-w-[610px] transition-all duration-1000 ease-out ${copyVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <p className="mb-5 text-sm font-bold uppercase tracking-[0.24em] text-[#B88F46]" style={{
            fontFamily: "'Raleway', Arial, sans-serif"
          }}>
              Continue Exploring
            </p>

            <h2 id="finaldiscoverycta-title" className="font-normal leading-[1.04] tracking-[-0.04em] text-[#073F31]" style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(3rem, 4.7vw, 5.25rem)"
          }}>
              Start discovering
              <br />

              <em className="font-normal text-[#0B5A45]">
                better golf trips
              </em>

              <br />
              across Asia.
            </h2>

            <div aria-hidden="true" className="mt-7 h-px w-12 bg-[#B88F46]" />

            <p className="mt-7 max-w-[535px] text-[15px] font-normal leading-[1.85] text-[#506B63] sm:text-[16px]" style={{
            fontFamily: "'Raleway', Arial, sans-serif"
          }}>
              Explore courses and destinations across Asia, compare what suits
              your trip and discover where you may want to play next.
            </p>

            <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6" style={{
            fontFamily: "'Raleway', Arial, sans-serif"
          }}>
              <a href="https://ideal-jay.10web.cloud/course-finder/" className="group inline-flex min-h-[52px] items-center justify-center gap-3 rounded-[7px] bg-[#BFFF00] px-7 py-3 text-[12px] font-bold uppercase tracking-[0.09em] text-[#073F31] shadow-[0_10px_28px_rgba(7,63,49,0.12)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#B3EF00] hover:shadow-[0_14px_34px_rgba(7,63,49,0.18)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#073F31] focus-visible:ring-offset-2 focus-visible:ring-offset-[#F7F3E9]">
                Find Courses

                <ArrowRight aria-hidden="true" className="size-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.8} />
              </a>

              <button type="button" disabled aria-disabled="true" title="Destinations page coming soon" className="inline-flex min-h-[46px] cursor-not-allowed items-center gap-3 border-b border-[#B8A789] py-2 text-[12px] font-bold uppercase tracking-[0.08em] text-[#667970] opacity-65">
                Explore Destinations

                <ArrowRight aria-hidden="true" className="size-4" strokeWidth={1.7} />
              </button>
            </div>
          </div>
        </div>

        {/* Right coastal golf image */}
        <div ref={imageRef} className={`relative min-h-[430px] overflow-hidden transition-opacity duration-1000 ease-out sm:min-h-[500px] lg:min-h-[620px] ${imageVisible ? "opacity-100" : "opacity-0"}`}>
          <img src={FINAL_CTA_IMAGE_URL} alt="Coastal golf course overlooking the sea at golden hour" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" style={{
          objectPosition: "center center"
        }} />

          {/* Ivory fade only — no dark image overlay */}
          <div aria-hidden="true" className="absolute inset-y-0 left-0 hidden w-[31%] bg-gradient-to-r from-[#F7F3E9] via-[#F7F3E9]/68 to-transparent lg:block" />

          <div aria-hidden="true" className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-[#F7F3E9]/25 to-transparent lg:hidden" />
        </div>
      </div>
    </section>;
}